import { useCallback, useLayoutEffect, useRef } from 'react';

// custom implementation of useEffectEvent from React v19
export const useEffectEvent = <Args extends any[], Result extends any>(callback: (...args: Args) => Result) => {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback((...args: Args) => {
    return callbackRef.current(...args);
  }, []);
};
